const userConstants = {
  PERSONAL_DETAIL_REQUEST: 'PERSONAL_DETAIL_REQUEST',
  PERSONAL_DETAIL_SUCCESS: 'PERSONAL_DETAIL_SUCCESS',
  PERSONAL_DETAIL_FAILURE: 'PERSONAL_DETAIL_FAILURE',
  EMAIL_CHANGED: 'EMAIL_CHANGED'
};

export default userConstants;
